import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useHasAnonymousError } from '../../FormView/FormView';
import Details, {DetailsItem} from '../../Details/Details';
import Dropdown from '../../Dropdown/Dropdown';
import DatePickerUI from '../../DatePicker/DatePicker';
import BooleanRadio from '../../BooleanRadio/BooleanRadio';
import { TextField } from '@mui/material';

function GenerateInstallationFields(props, {errorElements = []}) {
	const { t } = useSelector(redux => redux.store)
	const data = props.data

	const hasAnonymousError = useHasAnonymousError(errorElements)

	function getInput(field) {
		const { type } = field
		switch(type) {
			case 'select':
				return <Dropdown
					data-notrequired={!field.required || null}
					fullWidth
					value={field.value}
					name={field.name}
					options={field.options}
					readOnly={field.readOnly}
					error={ hasAnonymousError(field.name) }
				/>
			case 'boolean':
				return <BooleanRadio
					data-notrequired={!field.required || null}
					name={field.name}
					label={field.label}
					t={ t }
					defaultValue={field.value}
					readOnly={field.readOnly}
				/>
			case 'text':
				return (
					<TextField
						variant="standard"
						inputProps={{'data-notrequired': !field.required || null}}
						fullWidth
						defaultValue={field.value}
						name={field.name}
						multiline={true}
						readOnly={field.readOnly}
						error={ hasAnonymousError(field.name) } />
				);
			case 'string':
				return (
					<TextField
						variant="standard"
						inputProps={{'data-notrequired': !field.required || null}}
						fullWidth
						defaultValue={field.value}
						name={field.name}
						readOnly={field.readOnly}
						error={ hasAnonymousError(field.name) } />
				);
			case 'number':
				return (
					<TextField
						variant="standard"
						inputProps={{'data-notrequired': !field.required || null}}
						fullWidth
						defaultValue={field.value}
						type="number"
						name={field.name}
						readOnly={field.readOnly}
						error={ hasAnonymousError(field.name) } />
				);
			case 'decimal':
				return (
					<TextField
						variant="standard"
						inputProps={{
							'data-notrequired': !field.required || null,
							'pattern': /^\d*(\.\d{0,2})?$/,
							'step': '.01'
						}}
						fullWidth
						defaultValue={field.value.replace(',', '.')}
						type="number"
						name={field.name}
						readOnly={field.readOnly}
						error={ hasAnonymousError(field.name) } />
				);
			case 'date':
				return <DatePickerUI
					t={t}
					data-notrequired={!field.required || null}
					label={t.select_date}
					name={field.name}
					value={field.value}
					readOnly={field.readOnly}
					error={ hasAnonymousError(field.name) }
				/>
			default:
				return type
		}
	}

	function getItemComponents(data) {

		const keys = Object.keys(data);
		const items = [];
		const fields = [];
		keys.forEach((item, index) => {
			const field = data[item];
			field.name = item;
			fields.push(
				<DetailsItem
					key={index}
					label={field.label}
					type={field.type}
					required={field.required}
					readOnly={field.readOnly}
					error={ hasAnonymousError(field.name) }
				>
					{getInput(field)}
				</DetailsItem>
			)
		})


		items.push(fields.splice(0, Math.ceil(keys.length / 2)), fields)

		return items

	}

	function contentGetsRendered() {
		const items = getItemComponents(data);
		const fields = items.map((item, index) => {
			return (
				<div key={index} className="grid-1-2">
					<Details header={(index === 0) ? props.header : ''}>
						{item}
					</Details>
				</div>
			)

		});

		return fields
	}
	return (
		<div className="grid-inline grid-inline-start">
			{contentGetsRendered()}
		</div>
	);

}

GenerateInstallationFields.propTypes = {
	data: PropTypes.object.isRequired,
	header: PropTypes.string.isRequired,
}

export default GenerateInstallationFields
